/* ⚠️ GENERATED from app/services/insightsView.ts by gen-twins.mjs — edit the TypeScript, not this. */
/* ═══════════════════════════════════════════════════════════════════════════
   📊 insightsView.ts — the server's audience (insightsRoutes.js) as a screen draws it.

   🟥 THE OLD SCREEN SHOWED PERCENTAGES OF WHOEVER IT COULD PLACE. Ten viewers,
      one of them misread as Kazakhstan and nine unknown → "Kazakhstan 100%".
   🟢 NOW every percentage says what it is a percentage of:
        · countries — of EVERYONE described, with "Unknown" as its own row, so
          the rows add up to the audience and never overstate one country;
        · age and gender — of the people who told us (an empty answer is not
          "other"), and the screen says how many that is (`ageBase`, `genderBase`).
   Plain logic: the phone and the browser draw the same numbers.
   ═══════════════════════════════════════════════════════════════════════════ */
export const AGE_LABELS = {
  a13_17: '13-17',
  a18_24: '18-24',
  a25_34: '25-34',
  a35_44: '35-44',
  a45_54: '45-54',
  a55p: '55+'
};
export const TOP_COUNTRIES = 5;
const pct = (n, of) => of > 0 ? Math.round(n / of * 100) : 0;

/**
 * The audience → { countries: [{ iso, pct, n, unknown? }], ageGroups, gender, … }.
 * `nameOf(iso)` gives the country's display name (flag + localized name).
 */
export function audienceToMetrics(a, nameOf, unknownLabel) {
  if (!a || !(a.base > 0)) {
    return {
      base: 0,
      countries: [],
      ageGroups: null,
      gender: null,
      ageBase: 0,
      genderBase: 0,
      source: a && a.source
    };
  }
  const base = a.base;
  const ranked = (a.countries || []).slice().sort((x, y) => y.n - x.n);
  const top = ranked.slice(0, TOP_COUNTRIES);
  const restN = ranked.slice(TOP_COUNTRIES).reduce((s, c) => s + c.n, 0);
  const countries = top.map(c => ({
    iso: c.iso,
    name: nameOf(c.iso),
    pct: pct(c.n, base),
    n: c.n
  }));
  if (restN > 0) countries.push({
    iso: '',
    name: '…',
    pct: pct(restN, base),
    n: restN,
    other: true
  });
  if (a.unknownCountry > 0) countries.push({
    iso: '',
    name: unknownLabel,
    pct: pct(a.unknownCountry, base),
    n: a.unknownCountry,
    unknown: true
  });
  const ages = a.ages || {};
  const ageBase = Object.keys(AGE_LABELS).reduce((s, k) => s + (Number(ages[k]) || 0), 0);
  let ageGroups = null;
  if (ageBase > 0) {
    ageGroups = {};
    for (const [k, label] of Object.entries(AGE_LABELS)) ageGroups[label] = pct(Number(ages[k]) || 0, ageBase);
  }
  const g = a.genders || {};
  const m = Number(g.m) || 0;
  const f = Number(g.f) || 0;
  const o = Number(g.o) || 0;
  const genderBase = m + f + o;
  const gender = genderBase > 0 ? {
    male: pct(m, genderBase),
    female: pct(f, genderBase),
    other: pct(o, genderBase)
  } : null;
  return {
    base,
    countries,
    ageGroups,
    gender,
    ageBase,
    genderBase,
    source: a.source
  };
}
